
import { Component, Vue } from "nuxt-property-decorator";
import ContentPageLayout from "~/components/molecules/display/ContentPageLayout.vue";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import type { JumpNavItem } from "~/types/ContentPage";

@Component({
  scrollToTop: true,
  components: {
    ContentPageLayout,
  },
})
export default class SackwareVsLoseWare extends Vue {
  head() {
    return {
      ...generateMetaTags(
        this.$route.path,
        "pellets-sackware-lose-ware-vergleich",
      ),
      link: [{ rel: "canonical", href: this.$route.path }],
    };
  }

  get jumpNavItems(): JumpNavItem[] {
    return [
      {
        name: "Sackware",
        title: "Springen Sie zum Bereich: Sackware",
        href: { hash: "#anker-sackware" },
      },
      {
        name: "Lose Ware",
        title: "Springen Sie zum Bereich: Lose Ware",
        href: { hash: "#anker-lose-ware" },
      },
      {
        name: "Lageranforderungen",
        title: "Springen Sie zum Bereich: Lageranforderungen",
        href: { hash: "#anker-lageranforderungen" },
      },
      {
        name: "Qualitätsaspekte",
        title: "Springen Sie zum Bereich: Qualitätsaspekte",
        href: { hash: "#anker-qualitaetsaspekte" },
      },
      {
        name: "Für wen eignet sich welche Variante?",
        title: "Springen Sie zum Bereich: Für wen geeignet",
        href: { hash: "#anker-zielgruppen" },
      },
      {
        name: "Hybridlösung: Das Beste aus beiden Welten",
        title: "Springen Sie zum Bereich: Hybridlösung",
        href: { hash: "#anker-hybrid" },
      },
      {
        name: "Tipps",
        title: "Springen Sie zum Bereich: Praktische Tipps",
        href: { hash: "#anker-tipps" },
      },
      {
        name: "Tipps für die Entscheidung",
        title: "Springen Sie zum Bereich: Entscheidungshilfe",
        href: { hash: "#anker-entscheidung" },
      },
    ];
  }
}
